export const MCC_DEFAULT_KEY = "default";

export const MCC_CATALOG: Record<string, string> = {
  [MCC_DEFAULT_KEY]: "Padrão",
  "1520": "Construção civil - residencial e comercial",
  "1711": "Instalações hidráulicas, aquecimento e ar-condicionado",
  "1731": "Serviços de instalações elétricas",
  "1740": "Alvenaria e revestimentos",
  "1750": "Marcenaria e carpintaria",
  "1761": "Telhados e serralheria",
  "1771": "Serviços de concretagem",
  "1799": "Serviços de construção especializados",
  "2741": "Editoração e impressão",
  "2791": "Composição e pré-impressão",
  "2842": "Produtos de limpeza especializados",
  "4119": "Serviços de ambulância",
  "4121": "Táxis e transporte executivo",
  "4214": "Transporte de cargas",
  "4215": "Serviços de entrega e courier",
  "4225": "Armazenagem e estocagem",
  "4457": "Aluguel de embarcações",
  "4468": "Marinas e serviços náuticos",
  "4789": "Serviços de transporte",
  "4812": "Equipamentos de telecomunicação",
  "5013": "Autopeças e suprimentos automotivos",
  "5021": "Móveis comerciais e de escritório",
  "5039": "Materiais de construção",
  "5044": "Equipamentos fotográficos e de cópia",
  "5045": "Computadores, periféricos e software",
  "5046": "Equipamentos comerciais",
  "5047": "Equipamentos médicos e hospitalares",
  "5051": "Centros de serviços de metais",
  "5065": "Peças e equipamentos elétricos",
  "5072": "Ferragens e suprimentos",
  "5074": "Equipamentos hidráulicos e de aquecimento",
  "5085": "Suprimentos industriais",
  "5094": "Joias e pedras preciosas (atacado)",
  "5099": "Bens duráveis",
  "5111": "Papelaria e material de escritório",
  "5122": "Produtos farmacêuticos (distribuição)",
  "5131": "Tecidos e aviamentos",
  "5137": "Uniformes e roupas comerciais",
  "5139": "Calçados (atacado)",
  "5193": "Suprimentos para floricultura",
  "5198": "Tintas e vernizes",
  "5199": "Bens não duráveis",
  "5211": "Madeireiras e materiais de construção",
  "5251": "Lojas de ferragens",
  "5261": "Jardinagem e paisagismo",
  "5300": "Clubes de atacado",
  "5311": "Lojas de departamento",
  "5331": "Lojas de variedades",
  "5399": "Mercadorias gerais",
  "5422": "Açougues e frigoríficos",
  "5441": "Doces e confeitaria",
  "5499": "Mercearias e alimentos",
  "5511": "Concessionárias de veículos",
  "5521": "Revenda de veículos usados",
  "5532": "Lojas de pneus",
  "5533": "Autopeças e acessórios",
  "5551": "Concessionárias de embarcações",
  "5571": "Concessionárias de motocicletas",
  "5599": "Concessionárias diversas de veículos",
  "5611": "Roupas masculinas",
  "5651": "Vestuário em geral",
  "5661": "Lojas de calçados",
  "5681": "Peles e artigos de couro",
  "5697": "Alfaiataria e ajustes",
  "5699": "Vestuário e acessórios diversos",
  "5712": "Móveis e decoração",
  "5714": "Cortinas e estofados",
  "5719": "Artigos para o lar",
  "5722": "Eletrodomésticos",
  "5732": "Lojas de eletrônicos",
  "5733": "Instrumentos musicais",
  "5734": "Lojas de software",
  "5735": "Lojas de discos e mídia",
  "5815": "Bens digitais - mídia",
  "5816": "Bens digitais - jogos",
  "5818": "Bens digitais - aplicativos",
  "5912": "Farmácias e drogarias",
  "5921": "Bebidas alcoólicas",
  "5931": "Brechós e lojas de usados",
  "5932": "Antiquários",
  "5935": "Ferro-velho e sucata",
  "5940": "Lojas de bicicletas",
  "5941": "Artigos esportivos",
  "5942": "Livrarias",
  "5943": "Papelaria e material escolar",
  "5944": "Joalherias e relojoarias",
  "5945": "Brinquedos e hobbies",
  "5946": "Lojas de fotografia",
  "5947": "Presentes e souvenirs",
  "5948": "Malas e artigos de couro",
  "5949": "Tecidos e armarinhos",
  "5971": "Galerias e comércio de arte",
  "5976": "Produtos ortopédicos e próteses",
  "5977": "Cosméticos e perfumaria",
  "5992": "Floriculturas",
  "5993": "Tabacarias",
  "5995": "Pet shops e produtos para animais",
  "5999": "Varejo diversos",
  "6011": "Instituições financeiras (saque)",
  "7210": "Lavanderias e serviços de limpeza",
  "7216": "Lavanderia a seco",
  "7221": "Estúdios fotográficos",
  "7230": "Salões de beleza e barbearias",
  "7251": "Conserto de calçados",
  "7261": "Serviços funerários",
  "7273": "Serviços de acompanhantes",
  "7296": "Aluguel de roupas",
  "7297": "Casas de massagem",
  "7298": "Spas e estética",
  "7299": "Serviços pessoais diversos",
  "7311": "Serviços de publicidade",
  "7321": "Agências de crédito",
  "7333": "Fotografia e arte comercial",
  "7338": "Cópias e reprografia",
  "7342": "Dedetização e desinfecção",
  "7349": "Limpeza e manutenção predial",
  "7361": "Agências de emprego",
  "7372": "Programação e processamento de dados",
  "7379": "Manutenção de computadores",
  "7392": "Consultoria e gestão",
  "7393": "Segurança e vigilância",
  "7394": "Aluguel de equipamentos",
  "7395": "Laboratórios fotográficos",
  "7399": "Serviços empresariais",
  "7531": "Funilaria e pintura automotiva",
  "7534": "Recauchutagem de pneus",
  "7538": "Oficinas mecânicas",
  "7542": "Lava-rápidos",
  "7549": "Serviços de reboque",
  "7622": "Conserto de eletrônicos",
  "7629": "Conserto de eletrodomésticos",
  "7631": "Conserto de relógios e joias",
  "7699": "Serviços de reparo diversos",
  "7829": "Produção de vídeo e cinema",
  "7841": "Locadoras de vídeo",
  "7911": "Escolas de dança",
  "8011": "Médicos e consultórios",
  "8021": "Dentistas e ortodontistas",
  "8031": "Osteopatas",
  "8043": "Óticas",
  "8049": "Podólogos",
  "8050": "Cuidados de enfermagem",
  "8062": "Hospitais",
  "8071": "Laboratórios médicos e odontológicos",
  "8099": "Serviços médicos e de saúde",
  "8111": "Serviços jurídicos e advocacia",
  "8651": "Organizações políticas",
  "8734": "Laboratórios de análises",
  "8911": "Arquitetura e engenharia",
  "8931": "Contabilidade e auditoria",
  "8999": "Serviços profissionais",
};

export const getMccName = (mcc?: string | null): string => {
  if (!mcc) return MCC_CATALOG[MCC_DEFAULT_KEY];
  return MCC_CATALOG[mcc] ?? mcc;
};

export const getMccLabel = (mcc?: string | null): string => {
  if (!mcc || mcc === MCC_DEFAULT_KEY) return MCC_CATALOG[MCC_DEFAULT_KEY];
  return `${mcc} · ${getMccName(mcc)}`;
};
